import React, { useEffect, useState } from 'react';
import Modal from '../../Reports/blocks/Modal';
import CRPBlockWrapper from './CRPBlockWrapper';

const BLOCK_TITLE = "Story";

export default function CRPStoryBlock({title, chapters}) {
  const [storyOpen, setStoryOpen] = useState(false);

  return (
    <CRPBlockWrapper title={BLOCK_TITLE}>
      <div className='storyBlock'>
        <a href='#' onClick={() => setStoryOpen(true)}>{title}</a>
        {storyOpen && (<Modal isOpen={storyOpen} renderCloseIcon={true} onClose={() => setStoryOpen(false)}>
          <div className='storyModalWrapper'>
            <div className='storyModalTitle'>{title}</div>
            <div className='storyModalPhrases'>
              {chapters.map((chapter, chapterIndex) => chapter.phrases.map((phrase, phraseIndex) => (<div className='storyModalPhrase' key={`c${chapterIndex}_p${phraseIndex}`}>{phrase}</div>)))}
            </div>
          </div>
        </Modal>)}
      </div>
    </CRPBlockWrapper>
  )
}